<template>
  <div>
    <h1>Dashboard Cajero</h1>
  </div>
</template>

<script>
export default {
  name: 'DashboardCajero'
}
</script>